import * as React from 'react';

import { FromToControl } from '../../../../../../../common/components/from_to_control';
import { InlineParam } from '../../../markup';

export interface IHouseYearProps {
  minYear?: number;
  maxYear?: number;
  onMinYearChanged(value: number | undefined): void;
  onMaxYearChanged(value: number | undefined): void;
}

interface IHouseYearState {
  minYear?: number;
  maxYear?: number;
}

const YEAR_MIN_VALUE = 1900;

export class HouseYear extends React.Component<IHouseYearProps, IHouseYearState> {
  public constructor(props: IHouseYearProps) {
    super(props);

    this.state = {
      minYear: props.minYear,
      maxYear: props.maxYear,
    };
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IHouseYearProps) {
    if (this.props.minYear !== nextProps.minYear) {
      this.setState({
        minYear: nextProps.minYear,
      });
    }

    if (this.props.maxYear !== nextProps.maxYear) {
      this.setState({
        maxYear: nextProps.maxYear,
      });
    }
  }

  public render() {
    return (
      <InlineParam>
        <FromToControl
          from={{
            onValueChange: (value: number) => {
              this.setState({
                minYear: value,
              });
            },
            onBlur: this.onMinYearBlurred,
            value: this.state.minYear,
            disablePrettyFormating: true,
            maxLength: 4,
          }}
          to={{
            onValueChange: (value: number) => {
              this.setState({
                maxYear: value,
              });
            },
            onBlur: this.onMaxYearBlurred,
            value: this.state.maxYear,
            disablePrettyFormating: true,
            maxLength: 4,
          }}
        />
      </InlineParam>
    );
  }

  private onMinYearBlurred = (): void => {
    this.props.onMinYearChanged(
      this.state.minYear === undefined
        ? undefined
        : this.state.minYear >= YEAR_MIN_VALUE
        ? this.state.minYear
        : YEAR_MIN_VALUE,
    );

    if (!!this.state.minYear && this.state.minYear < YEAR_MIN_VALUE) {
      this.setState({ minYear: YEAR_MIN_VALUE });
    }
  };

  private onMaxYearBlurred = (): void => {
    this.props.onMaxYearChanged(
      this.state.maxYear === undefined
        ? undefined
        : this.state.maxYear >= YEAR_MIN_VALUE
        ? this.state.maxYear
        : YEAR_MIN_VALUE,
    );

    if (!!this.state.maxYear && this.state.maxYear < YEAR_MIN_VALUE) {
      this.setState({ maxYear: YEAR_MIN_VALUE });
    }
  };
}
